import { useMutation } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import useUserStore from "@/modules/users/store";
import { TCronogramaForm, updateQuestionario } from "../../firestore";

type TUpdateCronogramaResponse = Awaited<ReturnType<typeof updateQuestionario>>;
/**
 * Finalizar resposta de inovação mutation hook
 * @returns Finalizar resposta de inovação mutation
 */
// prettier-ignore
export function useUpdateIncricao() {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresaId);

  return useMutation<TCronogramaDesafio | TUpdateCronogramaResponse , FirestoreError, TCronogramaForm>({
    mutationFn(item) {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      if (!item) {
        throw new Error("Empresa não selecionada");
      }

      return updateQuestionario(activeEmpresaId, item?.id || "", item);
    },
  });
}
